import { useTranslation } from 'react-i18next';

export default function Testimonials() {
  const { t } = useTranslation('common');

  const testimonials = [
    {
      name: 'María González',
      location: 'Indianápolis, IN',
      rating: 5,
      text: 'Esta tienda es increíble. Encuentro todos los productos mexicanos y hondureños que necesito y que no consigo en otros lugares. Los precios son muy buenos y la atención es excelente. Me siento como en casa cada vez que vengo.'
    },
    {
      name: 'José Ramírez',
      location: 'Indianápolis, IN',
      rating: 5,
      text: 'La mejor tienda centroamericana en Indianápolis sin duda. Tienen una variedad impresionante de productos de México, Honduras, El Salvador y Nicaragua, desde dulces hasta ingredientes para cocinar. El ambiente es muy familiar. Los dueños son muy amables y siempre te ayudan.'
    },
    {
      name: 'Ana Martínez',
      location: 'Indianápolis, IN',
      rating: 5,
      text: 'Excelente tienda con productos auténticos de El Salvador y Nicaragua. Los precios son justos y la calidad es muy buena. Me encanta que tienen productos de temporada y especialidades salvadoreñas. La ubicación es tranquila y segura para ir con la familia.'
    },
    {
      name: 'Luis Hernández',
      location: 'Indianápolis, IN',
      rating: 5,
      text: 'Desde que abrieron he comprado aquí y nunca me han decepcionado. Siempre tienen lo que busco de México, Honduras y Nicaragua, y si no, lo consiguen. Los dulces centroamericanos son los mismos que comía de niño. Precios accesibles y atención de primera. 100% recomendado.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-100 text-yellow-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {t('testimonials_badge')}
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {t('testimonials_title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('testimonials_subtitle')}
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-orange-100"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                ))}
              </div>

              {/* Text */}
              <p className="text-gray-700 text-base leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div>
                <p className="font-bold text-gray-900 text-base">{testimonial.name}</p>
                <p className="text-sm text-gray-600">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            {t('testimonials_cta_text')}
          </p>
          <a
            href="https://wa.me/13172790334"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-green-500 to-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:from-green-600 hover:to-green-700 transition-all shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            {t('testimonials_cta_button')}
          </a>
        </div>
      </div>
    </section>
  );
}
